export default "/imgs/investigation-09.png"